import {Message}    from '@angular/compiler/src/i18n/i18n_ast';
import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

const baseURL = 'https://kadaikoditech.com:4000/';

@Injectable({
	            providedIn: 'root'
            })
export class CommonHelper{

  public static attributeSubject = new BehaviorSubject<any>(null);
  public static attributeValues$ = CommonHelper.attributeSubject.asObservable();

	static delete(ctrl, isAdmin=false){

		const deletedIds = [];

		for(const id in ctrl.selectedIds){
			if(ctrl.selectedIds[id]){
				deletedIds.push(ctrl.selectedIds[id]);
				 console.log(deletedIds);
			}
		}
		if(deletedIds.length === 1){

			return ctrl.storageS.delete(deletedIds[0], ctrl.baseUrl).subscribe(
				(response) => {
					console.log(response.message);
					let msg = 'Successfully Deleted';
					ctrl.messageService.add(msg);
					if(ctrl.hasDialog){
						ctrl.closeDialog();
					}
					if(isAdmin || (ctrl.AdminData.type == 1))
					{
					ctrl.fetchAll();
					}
					else{
						ctrl.fetchAllByVendor();
					}
				},
				(error) => {
					console.log(error);
					let msg = 'Error';
					ctrl.messageService.add(msg);
				}
			);
		} else{
			return ctrl.storageS.deleteRows(deletedIds, ctrl.baseUrl).subscribe(
				(response) => {
					console.log(response.message);
					let msg = 'Successfully Deleted';
					ctrl.messageService.add(msg);
					if(isAdmin || (ctrl.AdminData.type == 1))
					{
					ctrl.fetchAll();
					}
					else{
						ctrl.fetchAllByVendor();
					}
				},
				(error) => {
					console.log(error);
					let msg = 'Error';
					ctrl.messageService.add(msg);
				}
			);
		}
	}

	static fetchAll(ctrl){
		return new Promise((resolve, reject)=>{
			ctrl.tableList = [];
			ctrl.storageS.getAll(ctrl.baseUrl).subscribe(
				(response) => {

					ctrl.tableList = response.data;
					ctrl.messageService.add('Successfully Added');
					resolve(true);
				},
				(error) => {

					ctrl.messageService.add('Error');
					resolve(false)
				}
			);
		})
	}

	static fetchById(id, ctrl, moduleName) {
		return new Promise((resolve, reject) => {
			ctrl.userData = [];
			ctrl.storageS.get(id, moduleName).subscribe(
				(response) => {
					ctrl.userData = response.data;
					resolve(response.data); // 👈 Make sure you're resolving only the data here
				},
				(error) => {
					ctrl.messageService.add('Error fetching data');
					reject(error); // or resolve(null) if you want to handle errors silently
				}
			);
		});
	}

	static fetchByType(ctrl){
		return new Promise((resolve, reject)=>{
			ctrl.tableList = [];
			ctrl.storageS.getByType(ctrl.baseUrl, ctrl.type).subscribe(
				(response) => {
				
					ctrl.rows = JSON.parse(JSON.stringify(response.data));
					ctrl.tableList = response.data;
					ctrl.messageService.add('Successfully Added');
					resolve(true);
				},
				(error) => {
					console.log(error);
					ctrl.messageService.add('Error');
					resolve(false)
				}
			);
		})
	}

	static countForAdmin(ctrl){
		
		return ctrl.storageS.countForAdmin(ctrl.baseUrl).subscribe(
			(response) => {
				
				ctrl.DashboardStatistics = response.data;
				ctrl.messageService.add('Successfully Fetched');
			},
			(error) => {
				console.log(error);
				ctrl.messageService.add('Error');
			}
		);
	}

	static countForVendor(ctrl){
		return ctrl.storageS.countForVendor(ctrl.model.id, ctrl.baseUrl).subscribe(
			(response) => {
				
				ctrl.DashboardStatistics = response.data;
				ctrl.messageService.add('Successfully Fetched');
			},
			(error) => {
				console.log(error);
				ctrl.messageService.add('Error');
			}
		);
	}

	static save(ctrl, values?){

		const model = values || ctrl.model

        
		if(model?.id){
			return new Promise((resolve, reject)=>{
				ctrl.storageS.update(model?.id, model, ctrl.baseUrl)
				.subscribe(
					(message: Message) => {

						let msg = 'Successfully Updated';

						ctrl.messageService.add(msg);
						if(ctrl?.hasDialog){
							ctrl.closeDialog();
						}
						resolve(true);
					},
					(error) => {
						console.log(error);
						let msg = 'Error';
						ctrl.messageService.add(msg);
						resolve(false)
					}
				);
			})

		} else{
			return ctrl.storageS.create(model, ctrl.baseUrl).subscribe(
				(message: Message) => {
				console.log(model);
					let msg = 'Successfully Added';
					ctrl.messageService.add(msg);
					return ctrl.closeDialog();
				},
				(error) => {
					console.log(error);
					let msg = 'Error';
					ctrl.messageService.add(msg);
				}
			);
		}
	}

	static login(ctrl){

		return new Promise((resolve, reject)=>{
			ctrl.storageS.login(ctrl.model, ctrl.baseUrl).subscribe(
				(response)=>{
					ctrl.messageService.add('Successfully Added');
					localStorage.setItem('AdminData', JSON.stringify(response))
					resolve(true);
				},
				(error)=>{
					console.log(error);
					resolve(false)
					ctrl.messageService.add('Error');
				}
			)
		})
	}

	static buildServerPath(model: any) {
  if (!model || model.zf === undefined || model.zf === null) {
    return;
  }

  try {
    // ✅ Convert string JSON safely
    if (typeof model.zf === 'string') {
      if (!model.zf.trim().startsWith('[')) {
        model.zf = [];
        return;
      }
      model.zf = JSON.parse(model.zf);
    }

    // ✅ Ensure array
    if (!Array.isArray(model.zf)) {
      model.zf = [];
      return;
    }

    model.zf.forEach((zf: any, index: number) => {
      if (!zf || typeof zf !== 'object') return;

      if (typeof zf.url !== 'string') zf.url = '';
      if (typeof zf.nm !== 'string') zf.nm = '';

      // ✅ SAFE includes()
      const hasBase = zf.url.includes(baseURL);
      const hasName = zf.url.includes(zf.nm);

      zf.url =
        `${hasBase ? '' : baseURL}` +
        `${hasName ? zf.url : zf.url + zf.nm}`;

      zf.a = index === 0 ? 1 : 0;
    });

  } catch (e) {
    console.error('Invalid zf data:', model.zf);
    model.zf = [];
  }
}


	static trimServerPath(model){
		if((model.zf !== undefined)){
			if(model.zf && model.zf.length){
				for(let zf of model.zf){
					zf.url = zf.url.replace(baseURL, '');
					zf.url = zf.url.replace(zf.nm, '');
					delete zf.a;
				}
			} else{
				model.zf = null;
			}
		}
	}

	static update(ctrl, id){

		return new Promise((resolve, reject)=>{

			ctrl.storageS.update(id, ctrl.data, ctrl.baseUrl).subscribe(
				(response)=>{
					resolve(true);
				},
				(error)=>{
					resolve(false)
					ctrl.messageService.add('Error');
				}
			)
		})
	}

	static status_update(ctrl, id){

		return new Promise((resolve, reject)=>{
			console.log(ctrl.data);
			console.log(ctrl.baseUrl);
			ctrl.storageS.status_update(id, ctrl.data, ctrl.baseUrl).subscribe(
				(response)=>{
					resolve(true);
					console.log(response)
					if(ctrl.hasDialog){
						ctrl.closeDialog();
					}
					if(ctrl.AdminData.type == 1)
					{
					ctrl.fetchAll();
					}
					else{
						ctrl.fetchAllByVendor();
					}
				},
				(error)=>{
					resolve(false)
					console.log(error)
					ctrl.messageService.add('Error');
				}
			)
		})
	}


  static getSelectedAtrributes(selAttributeValues: any){

    console.log(selAttributeValues);

    this.attributeSubject.next(selAttributeValues);

    CommonHelper.attributeSubject.next(selAttributeValues);

  }
}
